import { lazy, Suspense } from 'react'
import {
  createBrowserRouter,
  Navigate,
  Outlet,
  RouterProvider,
} from 'react-router-dom'

import { RoutePaths } from '@/enums'
import { MainLayout } from '@/layouts'
import { HomepageContextProvider } from '@/pages/Homepage/Context'

export const AppRoutes = () => {
  const Homepage = lazy(() => import('@/pages/Homepage'))

  // const pageAnimationOpts = {
  //   initial: 'hide',
  //   animate: 'show',
  //   exit: 'hide',
  //   variants: {
  //     hide: {
  //       opacity: 0,
  //     },
  //     show: {
  //       opacity: 1,
  //     },
  //   },
  //   transition: { duration: 0.5 },
  // }

  const router = createBrowserRouter([
    {
      path: RoutePaths.Root,
      element: (
        <Suspense fallback={<></>}>
          <Outlet />
        </Suspense>
      ),
      children: [
        {
          element: <MainLayout />,
          children: [
            {
              path: RoutePaths.Root,
              element: (
                <HomepageContextProvider>
                  <Homepage />
                </HomepageContextProvider>
              ),
            },
            {
              path: '*',
              element: <Navigate replace to={RoutePaths.Root} />,
            },
          ],
        },
      ],
    },
  ])

  return <RouterProvider router={router} />
}
